import type { StatusTone } from '@noor/ui';
import type { ChangeRequestStatus } from '../model/schema';

// Presentational mapping for the queue: a status to the badge tone it wears,
// and the i18n key that names it. Kept out of the widget so the two screens
// that render a request (the queue, and any future detail view) cannot
// disagree about what «Отклонено» looks like.

/**
 * The badge tone a status earns.
 *
 * `stale` and `withdrawn` are BOTH neutral rather than danger: neither is a
 * rejection, and colouring them red would tell a merchant their submission was
 * refused when in one case they withdrew it themselves and in the other it was
 * simply overtaken.
 */
const STATUS_TONES: Record<ChangeRequestStatus, StatusTone> = {
  pending: 'pending',
  approved: 'success',
  rejected: 'danger',
  withdrawn: 'neutral',
  stale: 'neutral',
  unknown: 'neutral',
};

export function statusTone(status: ChangeRequestStatus): StatusTone {
  return STATUS_TONES[status];
}

/** i18n key naming a status — `changeRequests.status.*`. */
export function statusLabelKey(status: ChangeRequestStatus): string {
  return `changeRequests.status.${status}`;
}

/** i18n key naming what the request would do — `changeRequests.operation.*`. */
export function operationLabelKey(operation: string): string {
  return `changeRequests.operation.${operation}`;
}

/** i18n key naming the kind of entity — `changeRequests.entity.*`. */
export function entityLabelKey(kind: string): string {
  return `changeRequests.entity.${kind}`;
}
